import { cssTheme } from '@uds/theme-utils';
import { css } from 'linaria';

export default () => {
  return {
    body: css`
      margin-top: ${cssTheme.gu2};
    `,
    header: css`
      margin-bottom: ${cssTheme.gu1};
      &&& {
        ${cssTheme.breakpoints.sm} {
          margin-bottom: ${cssTheme.gu2};
        }
      }
      &&& {
        ${cssTheme.breakpoints.md} {
          margin-bottom: 0;
        }
      }
    `,
  };
};
